import Vue from 'vue';
import store from '@/store';

export default class SalesForceContract {
  public vueInstance;

  // eslint-disable-next-line
  constructor(vueInstance: any) {
    this.vueInstance = vueInstance;
  }

  public async getContractHandler(planId: string) {
    try {
      const planUrl = `${process.env.VUE_APP_CUSTOMER_ORDER_MANAGER}/v1/plans/plan-status/${planId}`;
      const { data: planData } = await Vue.prototype.$http.get(planUrl);
      store.commit('zccContract/setChangePlanData', planData);
    } catch (error: any) {
      console.log('error on service getContractHandler', error);
    }
  }
}
